<div class="width-lg max-width-lg">
  <div>
    <strong>{{ supplier?.code }}</strong>
    <span class="float-right">
      <nz-tag [nzColor]="supplier?.status != null ? color[supplier.status] : ''">
        {{ supplier?.status != null ? status[supplier.status] : '' }}
      </nz-tag>
    </span>
  </div>
  <div nz-tooltip="{{ supplier?.name }}" [nzTooltipPlacement]="'top'">
    <small>{{ supplier?.name }}</small>
  </div>
  <nz-divider class="m-none"></nz-divider>
</div>
